import React from 'react'
import { Modal, Col, Row } from 'antd'
import { changeStringTime2 } from '../../../util'

export default class extends React.Component {
  render() {
    const { visible, record } = this.props

    return (
      <Modal
        title="预订详情"
        visible={visible}
        onOk={this.props.handleReserveOk}
        onCancel={this.props.handleReserveCancel}
        width="600px"
      >
        <Row style={{ marginBottom: '8px' }}>
          <Col span={5} offset={5}>
            id：
          </Col>
          <Col span={14}>{record.bills[0].id}</Col>
        </Row>

        <Row style={{ marginBottom: '8px' }}>
          <Col span={5} offset={5}>
            订单号：
          </Col>
          <Col span={14}>{record.bills[0].serial_number}</Col>
        </Row>

        <Row style={{ marginBottom: '8px' }}>
          <Col span={5} offset={5}>
            用户：
          </Col>
          <Col span={14}>{record.bills[0].member_name}</Col>
        </Row>

        <Row style={{ marginBottom: '8px' }}>
          <Col span={5} offset={5}>
            手机号：
          </Col>
          <Col span={14}>{record.bills[0].phone}</Col>
        </Row>

        <Row style={{ marginBottom: '8px' }}>
          <Col span={5} offset={5}>
            支付时间：
          </Col>
          <Col span={14}>{changeStringTime2(record.bills[0].paying_time)}</Col>
        </Row>

        <Row style={{ marginBottom: '8px' }}>
          <Col span={5} offset={5}>
            支付金额：
          </Col>
          <Col span={14}>{record.bills[0].amount}</Col>
        </Row>

        <Row style={{ marginBottom: '8px' }}>
          <Col span={5} offset={5}>
            实收金额：
          </Col>
          <Col span={14}>{record.bills[0].amount}</Col>
        </Row>

        <Row style={{ marginBottom: '8px' }}>
          <Col span={5} offset={5}>
            到店时间：
          </Col>
          <Col span={14}>{changeStringTime2(record.bills[0].consume_time)}</Col>
        </Row>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubBusiness/component/reserveDetail.js